import { Head, usePage } from "@inertiajs/react";
import { useState } from "react";

import Modal from "/components/Modal";
import Button from "/components/Button";
import TextField from "/components/TextField";
import PhoneField from "/components/PhoneField";
import PasswordField from "/components/PasswordField";
import DropZone from "/components/DropZone";

export default function AdminUserForm({
  data,
  setData,
  onSubmit,
  errors,
}) {
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  const handleCloseDeleteModal = () => {
    setIsDeleteModalOpen(false);
    setProjectToDelete(null);
  };

  const handleDeleteClick = (adminUser) => {
    setIsDeleteModalOpen(true);
  };

  const deleteAdminUser = async () => {
    await router.delete(`/admin/admin_users/${data.id}`);
    setIsDeleteModalOpen(false);
  };

  const setImage = (key, value) => {
    if (value) {
      setData(key, value);
      setData(`remove_${key}`, false);
    } else {
      setData(key, {});
      setData(`remove_${key}`, true);
    }
  };

  return (
    <>
      <Modal
        isOpen={isDeleteModalOpen}
        onClose={handleCloseDeleteModal}
        className="modal--autowidth"
      >
        <div className="modal__text">
          Вы уверены, что хотите<br />удалить этого пользователя?
        </div>

        <div className="modal__actions">
          <Button onClick={deleteAdminUser} className="btn btn--dark">Удалить</Button>
          <Button onClick={handleCloseDeleteModal}>Отменить</Button>
        </div>
      </Modal>

      <div className="frm-wrapper">
        <form className="frm" onSubmit={onSubmit}>
          <div className="actions-bar">
            <div>
              <button type="submit" className="lnk lnk--green">Сохранить</button>
            </div>

            <div>
              <a href="/admin/admin_users" className="lnk">Отмена</a>
              {data.id && <Button onClick={() => setIsDeleteModalOpen(true)} className="lnk lnk--red">Удалить</Button>}
            </div>
          </div>

          <div className="flex-row gap-3">
            <div>
              <DropZone
                label="Загрузка изобржения 512×512"
                value={data.photo}
                onChange={value => setImage("photo", value)}
                className="inpt-dropzone-admin-user-photo"
              />
            </div>
            <div className="frm">
              <div className="inpt-line">
                <TextField
                  label="Имя Фамилия"
                  placeholder="Введите Имя и Фамилию"
                  value={data.name_ru}
                  onChange={value => setData("name_ru", value)}
                  errors={errors?.name_ru}
                />

                <TextField
                  label="First & Last Name"
                  placeholder="Please specify the first and last names"
                  value={data.name_en}
                  onChange={value => setData("name_en", value)}
                  errors={errors?.name_en}
                />
              </div>

              <div className="inpt-line">
                <TextField
                  label="Телеграм"
                  placeholder="@tgname"
                  value={data.telegram_username}
                  onChange={value => setData("telegram_username", value)}
                  errors={errors?.telegram_username}
                />

                <PhoneField
                  label="Whatsapp"
                  value={data.whatsapp_number}
                  onChange={value => setData("whatsapp_number", value)}
                  errors={errors?.whatsapp_number}
                />
              </div>

              <div className="inpt-line">
                <TextField
                  label="Электронная почта"
                  placeholder="Введите email"
                  value={data.email}
                  onChange={value => setData("email", value)}
                  errors={errors?.email}
                />

                <PasswordField
                  label="Пароль"
                  placeholder={data.id ? "Введите пароль для изменения" : "Пароль будет сгенерирован автоматически"}
                  value={data.password}
                  onChange={value => setData("password", value)}
                  errors={errors?.password}
                  disabled={!data.id}
                />
              </div>
            </div>
          </div>
        </form>
      </div>
    </>
  );
}
